import { useEffect, useRef } from 'react'

export function useOnChange<T>(callback: Function, dependency: T) {
	const ref = useRef<T>()
	useEffect(() => {
		if (dependency && ref.current !== undefined && ref.current !== dependency) {
			callback()
		}
		if (!ref.current) {
			ref.current = dependency
		}
	}, [dependency])
}
